import filter from 'js/filter'
let one_option = {
    backgroundColor: '#2A2F42',
    title : {
        text: '历年投资事件（金额）统计图',
        left: '10px',
        top: '16px',
        textStyle: {
            color: '#E9E9EB',
            fontSize: 16,
            lineHeight: 16
        }
    },
    tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket, callback) {
            //x轴名称
            var name; 
            var time_tag = '年'
            if(params[0].name.length == 4) {
                name = params[0].name
            } else {
                params[0].name[0] == 0 ? name = params[0].name[1] :  name = params[0].name
                time_tag = '月'
            }
            //图表title名称
            var seriesName1 = params[0].seriesName
            var seriesName2 = params[1].seriesName
            //值
            var value1 = params[0].value
            var value2 = filter.amountRateChange(params[1].value,3,3)

            return name + time_tag + '<br />' + seriesName1 + '：' + value1 + '<br />' + seriesName2 + '：' + value2
        }
    },
    grid: {
        left: '20px',
        right: '20px',
        top: '80px',
        bottom: '10px',
        containLabel: true
    },
    legend: {
        data:['事件数量','投资金额'],
        top: '0',
        right: '10px',
        top: '16px',
        itemWidth: 10,
        itemHeight: 10,
        selectedMode: false,
        icon: "circle",
        textStyle: {
            color: '#BCBDC1',
            fontSize: 12
        }
    },
    xAxis: [
        {
            type: 'category',
            data: [],
            axisPointer: {
                type: 'shadow'
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#40444F',
                    width: 1
                }
            },
            axisLabel: {
                textStyle: {
                    color: '#797B83'
                }
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '事件数量',
            nameTextStyle: {
                color: '#797B83'
            },
            scale: true,
            axisLabel: {
                formatter: '{value}',
                textStyle: {
                    color: '#797B83'
                }
            },
            splitLine: {
                show: false
            },
            min: 0,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            minInterval: 1
        },
        {
            type: 'value',
            name: '投资金额（美元）',
            nameTextStyle: {
                color: '#797B83'
            },
            scale: true,
            axisLabel: {
                formatter: (obj) => {
                  return filter.amountRateChange(obj,3,3)
                },
                textStyle: {
                    color: '#797B83'
                }
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: '#40444F',
                    width: 1,
                    type: 'dashed',
                }
            },
            min: 0,
            minInterval: 10000
        }
    ],
    series: [
        {
            name:'事件数量',
            type:'bar',
            barWidth: 8,
            itemStyle: {
                normal: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#17baf2'
                        }, {
                            offset: 1,
                            color: '#1893fe'
                        }]
                    },
                    barBorderRadius: [10, 10, 0, 0]
                }

            },
            data:[]
        },
        {
            name:'投资金额',
            type:'line',
            yAxisIndex: 1,
            itemStyle: {
                normal: {
                    color: {
                        type: 'linear',
                        x: 1,
                        y: 0,
                        x2: 0,
                        y2: 0,
                        colorStops: [{
                            offset: 0,
                            color: '#feb86f'
                        }, {
                            offset: 1,
                            color: '#f79a95'
                        }]
                    }
                }
            },
            data:[]
        }
    ]
}

let two_option = {
    backgroundColor: '#2A2F42',
    title : {
        text: '投资轮次占比',
        left: '10px',
        top: '16px',
        textStyle: {
            color: '#E9E9EB',
            fontSize: 16,
            lineHeight: 16
        }
    },
    legend: {
        data:[],
        top: 'middle',
        align: 'left',
        left: '197px',
        itemWidth: 10,
        itemHeight: 10,
        icon: "circle",
        selectedMode: false,
        textStyle: {
            color: '#BCBDC1',
            fontSize: 12
        }
    },
    tooltip: {
        trigger: 'item',
        formatter: "{b}: {c} ({d}%)"
    },
    series : [
        {
            name: '轮次',
            type: 'pie',
            radius: [45, 75],
            center: [90, 158],
            label: {
                normal: {
                    show: false,
                }
            },
            data: []
        }
    ]
}

let three_option = {
    backgroundColor: '#2A2F42',
    title : {
        text: '机构当前布局情况',
        left: '10px',
        top: '16px',
        textStyle: {
            color: '#E9E9EB',
            fontSize: 16,
            lineHeight: 16
        }
    },
    tooltip: {
        trigger: 'axis'
    },
    grid: {
        left: '20px',
        right: '20px',
        top: '80px',
        bottom: '10px',
        containLabel: true
    },
    legend: {
        data:['事件数量'],
        top: '0',
        right: '10px',
        top: '16px',
        itemWidth: 10,
        itemHeight: 10,
        icon: "circle",
        textStyle: {
            color: '#BCBDC1',
            fontSize: 12
        }
    },
    xAxis: [
        {
            type: 'category',
            data: [],
            axisPointer: {
                type: 'shadow'
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    color: '#797B83'
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#40444F',
                    width: 1
                }
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '事件数量',
            nameTextStyle: {
                color: '#797B83'
            },
            axisLabel: {
                formatter: '{value}',
                textStyle: {
                    color: '#797B83'
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#40444F',
                    width: 1,
                    type: 'dashed',
                }
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            min: 0,
            minInterval: 1
        }
    ],
    series: [
        {
            name:'事件数量',
            type:'bar',
            data:[],
            barWidth: 8,
            itemStyle: {
                normal: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#17baf2'
                        }, {
                            offset: 1,
                            color: '#1893fe'
                        }]
                    },
                    barBorderRadius: [10, 10, 0, 0]
                }

            },
        }
    ]
}

export { one_option, two_option, three_option }
